import FlexCentered from '../../../../components/Common/FlexCentered';
import Typography from 'kingpin/atoms/Typography';
import Row from '../../../../components/Common/Row';
import DateInput from '../../../../components/DateInput';
import React from 'react';
import Loading from '../../../../components/Loading';

const MetricPreview = ({
  data,
  invalidMessage,
  isLoading,
}: {
  data?: string;
  invalidMessage?: string;
  isLoading: boolean;
}) => {
  return (
    // Recessed below the metric's details, in either theme
    <div
      style={{
        backgroundColor: 'var(--color-bg-sunken)',
        border: '1px solid var(--color-border-tertiary)',
        padding: 16,
        height: 180,
        position: 'relative',
        borderRadius: 8,
      }}
    >
      <FlexCentered style={{ height: '100%' }}>
        {isLoading && <Loading />}
        {!isLoading && invalidMessage && (
          <Typography.Body type="Body 14 Bold" color={'var(--color-grey-2)'}>
            {invalidMessage}
          </Typography.Body>
        )}
        {!isLoading && !invalidMessage && (
          <Typography.Header type="H1">{data}</Typography.Header>
        )}
      </FlexCentered>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          paddingTop: 8,
          paddingLeft: 16,
          paddingRight: 16,
        }}
      >
        <Row centerAlign spaceBetween>
          <Typography.Header type="H5">Preview</Typography.Header>
          <DateInput />
        </Row>
      </div>
    </div>
  );
};

export default MetricPreview;
